import { ComponentProps } from 'react';

import { Trigger as RadixTrigger, TabsTriggerProps } from '@radix-ui/react-tabs';
import { twMerge } from 'tailwind-merge';

import { Button } from '../../../Button';

interface TriggerProps extends Omit<ComponentProps<typeof Button>, 'value' | 'variant'>, TabsTriggerProps {}

function Trigger({ value, className, disabled, children, ...props }: TriggerProps) {
  return (
    <RadixTrigger asChild value={value} disabled={disabled} className={twMerge('outline-none', className)}>
      <Button
        variant="nude"
        size="none"
        rounding="full"
        disabled={disabled}
        className="bg-neutral-100 p-3 text-xs font-medium text-primary radix-state-active:bg-light-blue-100 radix-state-active:text-blue-500"
        {...props}
      >
        {children}
      </Button>
    </RadixTrigger>
  );
}

export { Trigger };
